import {post, get} from '@/utils/request'

// 获取激活奖励列表
// 查询激活奖励明细列表
export function getActivateBonusListAPI(data) {
    return post({
        data,
        url: 'commission/active-reward-record/activeRewardList'
    })
}

// 查询佣金总和和记录总数
export function getSumCountAndCommissionAPI(data) {
    return post({
        data,
        url: 'commission/active-reward-record/getSumCountAndCommission'
    })
}

// 查询激活奖励列表导出
// 查询激活奖励明细列表导出
export function activateBonusExportAPI(data) {
    return get({
        data,
        url: 'commission/active-reward-record/activeRewardListExport'
    })
}

// 详情-获取账单信息
export function getBillInfoAPI(data) {
    return post({
        data,
        url: 'commission/active-reward-record/getActiveBillInfo'
    })
}

// 详情-获取分账信息
export function getSubAccountInfoAPI(data) {
    return post({
        data,
        url: 'commission/active-reward-record/getSubAccountInfo'
    })
}

// 详情-获取资金流水信息
export function getMoneyFlowInfoAPI(data) {
    return post({
        data,
        url: 'commission/active-reward-record/getMoneyWater'
    })
}
